import { Component, inject, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Person } from '../../data/person';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { LookupItem } from '../../models/lookup-item';
import { Observable } from 'rxjs';
import { LookupDataService } from '../../services/lookup-data.service';
import { DateValidators } from '../../validators/date-validators';
import { IVisaType } from '../../data/visa-type';
import { format } from 'date-fns';


@Component({
  selector: 'app-person-dialog',
  templateUrl: './person-dialog.component.html',
  styleUrl: './person-dialog.component.scss'
})
export class PersonDialogComponent implements OnInit {

person: Person;
personType: string;
applicantName: string;
titles!: LookupItem[];
relationTypes!: LookupItem[];
maritalStatuses!: LookupItem[];
educationLevels!: LookupItem[];
countries!: LookupItem[];
visaTypes!: IVisaType[];
isVevo: any;
isVevoEmployee: any;


constructor(public dialogRef: MatDialogRef<PersonDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: {
      person: Person;
      personType: string;
      applicantName: string;
      isVevo: boolean;
      isVevoEmployee: boolean;
      titles: LookupItem[];
      relationTypes: LookupItem[];
      maritalStatuses: LookupItem[]; 
      educationLevels: LookupItem[];
      countries: LookupItem[];
      visaTypes: IVisaType[];
      
    }) {
      this.person = data.person || new Person();
      this.personType = data.personType || 'Person';
      this.applicantName = data.applicantName || 'the applicant';
      this.isVevo = data.isVevo || false;
      this.isVevoEmployee = data.isVevoEmployee || false;
      this.titles = data.titles;
      this.relationTypes = data.relationTypes;
      this.maritalStatuses = data.maritalStatuses;
      this.educationLevels = data.educationLevels;
      this.countries = data.countries;
      this.visaTypes = data.visaTypes;
     }

    get dialogTitle(): string {
      if(this.personType === 'nonIncludedChild'){
        return `Add Not Included Child`;
      } else if(this.personType === 'otherFamilyMember'){
        return `Add Family Member`;
      }
      else{
        return `Add ${this.personType}`;
      }
    }

    formBuilder = inject(NonNullableFormBuilder);
    
      personForm = this.formBuilder.group({
        title: [null as LookupItem | null],
        titleOther: this.formBuilder.control(''),
        firstname: this.formBuilder.control(''),
        surname: this.formBuilder.control(''),
        dob: this.formBuilder.control(''),
        relationToApplicant: [null as LookupItem | null],
        passportCountry: [null as LookupItem | null],
        countryofResidence: [null as LookupItem | null],
        passportNumber: [''],
        maritalStatus: [null as LookupItem | null],
        education: [null as LookupItem | null],
        occupation: [''],
        incapacitated: [''],
        financialDependancy: [''],
        inAustralia: [''],
        location: [null as LookupItem | null],
        arriveAustralia: [''],
        departAustralia: [''],
        holdAustralianVisa: [''],
        visaExpire: [''],
        visaType: [null as IVisaType | null]
      })
    
ngOnInit(): void {

  this.initializeForm();
  this.applyValidators();
}

initializeForm(){

this.personForm.patchValue({
    title: this.person.title,
    titleOther: this.person.titleOther,
    firstname: this.person.firstName,
    surname: this.person.surname,
    dob: this.person.dob instanceof Date ? format(this.person.dob, 'yyyy-MM-dd') : this.person.dob,
    relationToApplicant: this.person.realtionToApplicant,
    passportCountry: this.person.passportCountry,
    countryofResidence: this.person.countryResidence,
    passportNumber: this.person.passportNumber,
    maritalStatus: this.person.maritalStatus,
    education: this.person.education,
    occupation: this.person.occupation,
    incapacitated: this.person.incapacitated,
    financialDependancy: this.person.financialDependancy,
    inAustralia: this.person.inAustralia,
    location: this.person.location,
    arriveAustralia: this.person.arriveAustralia instanceof Date ? format(this.person.arriveAustralia, 'yyyy-MM-dd') : this.person.arriveAustralia,
    departAustralia: this.person.departAustralia instanceof Date ? format(this.person.departAustralia, 'yyyy-MM-dd') : this.person.departAustralia,
    holdAustralianVisa: this.person.holdAustralianVisa,
    visaExpire: this.person.visaExpire instanceof Date ? format(this.person.visaExpire, 'yyyy-MM-dd') : this.person.visaExpire,
    visaType: this.person.visaType
  });

  // Subscribe to form value changes and update the person object
  this.personForm.valueChanges.subscribe(value => {
    if (value) {
      Object.assign(this.person, {
        title: value.title,
        titleOther: value.titleOther,
        firstName: value.firstname, // Note: form uses 'firstname', person uses 'firstName'
        surname: value.surname,
        dob: value.dob,
        realtionToApplicant: value.relationToApplicant,
        passportCountry: value.passportCountry,
        countryResidence: value.countryofResidence,
        passportNumber: value.passportNumber,
        maritalStatus: value.maritalStatus,
        education: value.education,
        occupation: value.occupation,
        incapacitated: value.incapacitated,
        financialDependancy: value.financialDependancy,
        inAustralia: value.inAustralia,
        location: value.location,
        arriveAustralia: value.arriveAustralia,
        departAustralia: value.departAustralia,
        holdAustralianVisa: value.holdAustralianVisa,
        visaExpire: value.visaExpire,
        visaType: value.visaType
      });
    }
  });
}

    
private applyValidators(): void {
     
  const relationControl = this.personForm.controls.relationToApplicant;
  const passportCountryControl = this.personForm.controls.passportCountry;
  const passportNumberControl = this.personForm.controls.passportNumber;
  const dobControl = this.personForm.controls.dob;
  const firstnameControl = this.personForm.controls.firstname;
  const surnameControl = this.personForm.controls.surname;
  const maritalStatusControl = this.personForm.controls.maritalStatus;
  const educationControl = this.personForm.controls.education;
  const occupationControl = this.personForm.controls.occupation;
  const inAustraliaControl = this.personForm.controls.inAustralia;
 const incapacitatedControl = this.personForm.controls.incapacitated;

  firstnameControl.setValidators([Validators.required]);
  surnameControl.setValidators([Validators.required]);
  dobControl.setValidators([]);
  relationControl.setValidators([]);
  
  passportCountryControl.setValidators([]);
  passportNumberControl.setValidators([]);
  maritalStatusControl.setValidators([]);
  educationControl.setValidators([]);
  occupationControl.setValidators([]);
  inAustraliaControl.setValidators([]);
  incapacitatedControl.setValidators([]);
  
  
if (this.personType === 'nonIncludedChild') {
    relationControl.setValidators([Validators.required]);
  } 

else if (this.personType === 'otherFamilyMember') {
        
    dobControl.setValidators([Validators.required, DateValidators.pastDate()]);

    if(this.isVevo){
      passportCountryControl.setValidators([Validators.required]);
      passportNumberControl.setValidators([Validators.required]);
    }
   else {
      relationControl.setValidators([Validators.required]);
    }
  }

  firstnameControl.updateValueAndValidity();
  surnameControl.updateValueAndValidity();
  dobControl.updateValueAndValidity();
  relationControl.updateValueAndValidity();
  passportCountryControl.updateValueAndValidity();
  passportNumberControl.updateValueAndValidity();
  maritalStatusControl.updateValueAndValidity();
  educationControl.updateValueAndValidity();
  occupationControl.updateValueAndValidity();
  inAustraliaControl.updateValueAndValidity();
  incapacitatedControl.updateValueAndValidity();


}


    get personRelationLabel(): string {
      return `This Person is ${this.applicantName}'s`;
    }

    get passportCountryLabel(): string {
      if(this.personType === 'nonIncludedChild'){
        return 'Country of Current Residence';
      }
      else{
          return 'Country of Passport';
        }

    }

    ageDifference(): number {
      return this.person
        ? (Person.ageDifference(this.person.dob)) ?? 0
        : 0;
    }


  close(): void {
        if(this.personForm.valid) {
          this.dialogRef.close(this.person);
        }
        else{
          this.debugFormErrors();
          this.personForm.markAllAsTouched();
          return;
        }

    
  }

  cancel(): void {
    this.dialogRef.close();
  }

  debugFormErrors(): void {
    console.log('Person form valid:', this.personForm.valid);
    console.log('Person form errors:', this.personForm.errors);
    
    Object.keys(this.personForm.controls).forEach(key => {
      const control = this.personForm.get(key);
      if (control && control.errors) {
        console.log(`Control '${key}' has errors:`, control.errors);
        console.log(`Control '${key}' value:`, control.value);
        console.log(`Control '${key}' touched:`, control.touched);
        console.log(`Control '${key}' dirty:`, control.dirty);
      }
    });
}

}
